import React from "react";
import t from "./typography.module.css";
import c from "../colors.module.css";
import cn from "classnames";

const RelatedDescription = ({ children, className, ...rest }) => {
  return (
    <p className={cn(t.relatedDescription, c.txtBlack, className)} {...rest}>
      {children}
    </p>
  );
};

export default RelatedDescription;
